export const REQUEST_GET = '@NOTIFICATION/REQUEST_GET';
export const REQUEST_CREATE = '@NOTIFICATION/REQUEST_CREATE';
export const REQUEST_DELETE = '@NOTIFICATION/REQUEST_DELETE';
export const REQUEST_DELETE_ALL = '@NOTIFICATION/REQUEST_DELETE_ALL';
export const GET = '@NOTIFICATION/GET';
export const CREATE = '@NOTIFICATION/CREATE';
export const DELETE = '@NOTIFICATION/DELETE';
export const DELETE_ALL = '@NOTIFICATION/DELETE_ALL';